import { Injector } from '@angular/core';
import { HandweaveDirectoryService } from '../handweave/handweave-directory.service';
import { HickoryDirectoryService } from '../hickory/hickory-directory.service';
import { BaseDirectoryService } from './base-directory.service';
import { Directory } from './models';
import { DIRECTORY_ID } from './token';

export class DirectoryInjector {

  /**
   * @param injector 
   * @param directoryId 
   * @returns a DirectoryService instance
   */
  static getDirectoryService(injector: Injector, directoryId: string): BaseDirectoryService {
    if (Directory.isLegacy(directoryId)) return this.getHickoryDirectory(injector, directoryId);
    else return this.getHandweaveDirectory(injector, directoryId);
  }

  static getHickoryDirectory(injector: Injector, directoryId: string): HickoryDirectoryService {
    // create a new injector to ensure a unique instance of the service
    const myInjector = Injector.create({
      providers: [
        { provide: DIRECTORY_ID, useValue: directoryId },
        { provide: HickoryDirectoryService, useClass: HickoryDirectoryService },
      ], 
      parent: injector,
      name: directoryId,
    });
    return myInjector.get<HickoryDirectoryService>(HickoryDirectoryService);
  }

  static getHandweaveDirectory(injector: Injector, directoryId: string): HandweaveDirectoryService {
    // create a new injector to ensure a unique instance of the service
    const myInjector = Injector.create({
      providers: [
        { provide: DIRECTORY_ID, useValue: directoryId },
        { provide: HandweaveDirectoryService, useClass: HandweaveDirectoryService },
      ], 
      parent: injector,
      name: directoryId,
    });
    return myInjector.get<HandweaveDirectoryService>(HandweaveDirectoryService);
  }
}
